import { Form } from "react-bootstrap";


const UploadMultiFolders = ({ allowedExtensions, handleFolderChange }) => {
  return (
    <Form.Group className="mb-1">
      <Form.Label className="mb-1 fw-bold">
        Upload Folder
        <abbr title="Required" className="text-danger">*</abbr>
      </Form.Label>
      <Form.Control
        type="file"
        webkitdirectory
        multiple
        disabled
        accept={allowedExtensions.join(",")}
        onChange={handleFolderChange}
      />
    </Form.Group>
  );
};

export default UploadMultiFolders;
